// extracted by mini-css-extract-plugin
export var chevronIcon = "_by-2";
export var teamName = "_by-1";
export var teamSwitcherButton = "_by-0";